<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("Toolbar.petition") }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs10 lg3 ml-4
                    >{{ $t("Toolbar.policyData") }} <br /><br />
                    <!-- <v-btn color="#077893" outlined to="/policy-create">
                          <v-icon class="mr-1">mdi-plus</v-icon>
                          {{ $t("policyForm.crpolicy") }}
                        </v-btn> -->
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs7 lg4 mr-6>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-title class="mt-n12">
                <v-tabs v-model="tab" :color="ColorSlider">
                  <v-tabs-slider :color="ColorSlider"></v-tabs-slider>
                  <v-tab @click="Fn_GetData('all')">
                    {{ $t("petition.all") }}</v-tab
                  >
                  <v-tab @click="Fn_GetData('pending')">
                    {{ $t("petition.wait") }}
                  </v-tab>
                  <v-tab @click="Fn_GetData('wait')">
                    แจ้งวันที่ดำเนินการ
                  </v-tab>
                  <v-tab @click="Fn_GetData('approve')">
                    {{ $t("petition.approve") }}</v-tab
                  >
                  <v-tab @click="Fn_GetData('unapprove')">
                    {{ $t("petition.text16") }}</v-tab
                  >
                </v-tabs>
              </v-card-title>
              <v-card-text>
                <v-card outlined>
                  <v-data-table
                    calculate-widths
                    :headers="headers"
                    :items="ItemPetition"
                    class="rounded-lg"
                    :search="Search"
                    hide-default-footer
                    :page.sync="Page"
                    @page-count="PageCount = $event"
                    :items-per-page="ItemPerPage"
                    flat
                  >
                    <template v-slot:[`item.SendCancelId`]="{ item }">
                      <td class="text-center">
                        <div
                          class="text-center"
                          v-if="
                            item.SendCancelId === '' ||
                            item.SendCancelId === null
                          "
                        >
                          -
                        </div>
                        <div
                          class="text-center"
                          v-else-if="item.see_id === true"
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                color="#077893"
                                style="cursor: pointer"
                                small
                                @click="Fn_CopyDetail(item.SendCancelId)"
                                v-on="on"
                                >mdi-file-multiple-outline</v-icon
                              >
                            </template>
                            <span>{{ $t("consentlist.copy") }}</span>
                          </v-tooltip>
                          {{ item.SendCancelId }}
                        </div>
                        <div
                          class="text-center"
                          v-else-if="item.see_id === false"
                        >
                          ...
                        </div>
                        <center>
                          <v-btn
                            icon
                            color="#077893"
                            @click="fn_seeEmailAnalysis(item)"
                            text
                            ><v-icon>{{
                              item.see_id === true
                                ? "mdi-eye-off"
                                : "mdi-eye-settings"
                            }}</v-icon>
                          </v-btn>
                          <!-- <v-btn
                            v-if="tab == 0"
                            icon
                            :color="
                              item.Status === 'approve'
                                ? 'success'
                                : item.Status === 'pending'
                                ? 'warning'
                                : item.Status === 'unapprove'
                                ? 'error'
                                : item.Status === 'action'
                                ? 'info'
                                : item.Status === 'wait'
                                ? 'indigo'
                                : ''
                            "
                            @click="fn_seeEmailAnalysis(item)"
                            text
                            ><v-icon>{{
                              item.see_id === true
                                ? "mdi-eye-off"
                                : "mdi-eye-settings"
                            }}</v-icon>
                          </v-btn> -->
                        </center>
                      </td>
                    </template>
                    <template v-slot:[`item.TypeName`]="{ item }">
                      <div v-if="item.TypeName.length < 13">
                        {{ item.TypeName }}
                      </div>
                      <div v-else>
                        <v-tooltip top color="#077893" max-width="80vh">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{
                              item.TypeName
                            }}</span>
                          </template>
                          <span>{{ item.TypeName }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.NameTh`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.NameTh }}
                      </div>
                      <div v-else>
                        {{ item.NameEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.UpdatdeBy`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeBy }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeByEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.RequestAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.RequestAt }}
                      </div>
                      <div v-else>
                        {{ item.RequestAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.Type`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        <div v-if="item.Type == 'General'">แบบทั่วไป</div>
                        <div v-if="item.Type == 'Group'">แบบกลุ่ม</div>
                      </div>
                      <div v-else>
                        {{ item.Type }}
                      </div>
                    </template>
                    <template v-slot:[`item.Status`]="{ item }">
                      <!-- <div v-if="$t('default') === 'th'"> -->
                      <v-chip
                        v-if="item.Status == 'approve'"
                        color="success"
                        small
                        dark
                      >
                        {{ $t("petition.approve") }}
                      </v-chip>
                      <v-chip
                        v-else-if="item.Status == 'unapprove'"
                        color="error"
                        small
                        dark
                      >
                        {{ $t("petition.text16") }}
                      </v-chip>
                      <v-chip
                        v-else-if="item.Status == 'pending'"
                        color="warning"
                        small
                        dark
                      >
                        {{ $t("petition.wait") }}
                      </v-chip>
                      <v-chip
                        v-else-if="item.Status == 'action'"
                        color="info"
                        small
                        dark
                      >
                      เอกสารไม่สมบูรณ์
                      </v-chip>
                      <v-chip
                        v-else-if="item.Status == 'wait'"
                        color="indigo"
                        small
                        dark
                      >
                        แจ้งวันที่ดำเนินการ
                      </v-chip>
                      <!-- </div> -->
                      <!-- <div v-else>
                        <v-chip
                          v-if="item.Status == 'approve'"
                          color="success"
                          small
                          dark
                        >
                          Approve
                        </v-chip>
                        <v-chip
                          v-else-if="item.Status == 'unapprove'"
                          color="error"
                          small
                          dark
                        >
                          Unapprove
                        </v-chip>
                        <v-chip
                          v-else-if="item.Status == 'pending'"
                          color="warning"
                          small
                          dark
                        >
                          Pending
                        </v-chip>
                      </div> -->
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-layout>
                        <v-flex>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                icon
                                v-bind="attrs"
                                v-on="on"
                                color="#077893"
                                @click="Fn_ViewDetail(item)"
                                dark
                              >
                                <v-icon>mdi-text-box-search</v-icon>
                              </v-btn>
                            </template>
                            <span> {{ $t("consentlist.detail") }}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-data-table>
                  <v-pagination
                    :total-visible="7"
                    class="pt-2 pb-2"
                    circle
                    color="#077893"
                    v-model="Page"
                    :length="PageCount"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                  >
                  </v-pagination>
                </v-card>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <div v-if="loadingDownloadData">
          <OverlaySearch />
        </div>
        <v-overlay opacity="0" :value="loadingovl"></v-overlay>
        <DialogPetition
          :show="DialogPetition"
          :_detail="cancel"
          @closeDialog="DialogPetition = false"
        />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
import DialogPetition from "../../../components/dialog/DialogPetition.vue";
// import 'sweetalert2/src/sweetalert2.scss'

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogPetition, OverlaySearch },
  data: function () {
    return {
      Search: "",
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      ItemPetition: [],
      ItemDelete: [],
      DialogDelete: false,
      loadingDownloadData: false,
      DialogList: false,
      DialogPetition: false,
      load: false,
      loadingovl: false,
      item: "",
      cancel: "",
      ColorSlider: "#077893",
      ColorSliderAll: "#077893",
      tab: null,
    };
  },
  computed: {
    ...mapGetters(["DataPetition"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SendId: {
      get() {
        return this.DataPetition.SendId || "-";
      },
    },
    _SubjectRequest: {
      get() {
        return this.DataPetition.SubjectRequest || "-";
      },
    },
    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          value: "no",
          sortable: false,
          align: "center",
        },
        {
          text: this.$i18n.t("petition.text35"),
          value: "SendCancelId",
          sortable: false,
          align: "center",
        },
        {
          text: this.$i18n.t("petition.textName"),
          value: "NameTh",
          sortable: false,
          align: "left",
        },
        {
          text: this.$i18n.t("petition.text36"),
          align: "left",
          value: "TypeName",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.type"),
          value: "SourceSystem",
          align: "left",
          sortable: false,
        },
        // {
        //   text: this.$i18n.t("petition.textType"),
        //   value: "Type",
        //   align: "center",
        //   sortable: false,
        // },
        // {
        //   text: this.$i18n.t("dashboard.status"),
        //   value: "Status",
        //   align: "center",
        //   sortable: false,
        // },
        {
          text: this.$i18n.t("petition.text1"),
          value: "RequestAt",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("petition.text14"),
          value: "Status",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("policyForm.select"),
          align: "left",
          value: "action",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    this.Fn_GetData();
  },
  methods: {
    async Fn_GetData(val) {
      if (val == null) {
        val = "all";
      }
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        Status: val,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/AllCancelConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemPetition = response.data.Message;

            this.SendId = response.data.Message.SendId;
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.ItemPetition.length;

            var number = [];
            var status = false;
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemPetition) {
              this.ItemPetition[j].no = number[j];
              this.ItemPetition[j].statusActive = status;
            }
            for (var j in this.ItemPetition) {
              this.ItemPetition[j]["see_id"] = false;
            }

          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            // Toast.fire({
            //   icon: 'error',
            //   title: error.response.data.ErrorMessage
            // })
            this.$router.push("/profile");
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Check_Request(item) {
      item.statusActive = true;
      this.loadingovl = true;
      this.$store.dispatch("SET_DATAPETITON", item);

      var payload = {
        Type: this.cancel[0].Type,
        SendCancelId: item.SendCancelId,
        AccessToken: this.$cookies.get("OneAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/Pettition/GetRequest",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          item.statusActive = false;
          this.loadingovl = false;

          if (response.data.Status === "OK") {
            this.Check = response.data.Message;
            if (item.SendCancelId !== null) {
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("petition.text3"),
              });
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          item.statusActive = false;
          this.loadingovl = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    // Fn_OpenDialogPetition() {
    //   this.DialogPetition = true;
    // },
    Fn_ViewDetail(item) {
      this.$router.push({ path: "/petition-detail" });
      this.$store.dispatch("SET_DATAPETITON", item);
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    fn_seeEmailAnalysis(item) {
      if (item.see_id === true) {
        let objIndex = this.ItemPetition.findIndex((arr) => arr.no === item.no);
        let objdata = this.ItemPetition.find((arr) => arr.no === item.no);
        objdata["see_id"] = false;
        this.ItemPetition.splice(objIndex, 1, objdata);
      } else if (item.see_id === false) {
        let objIndex = this.ItemPetition.findIndex((arr) => arr.no === item.no);
        let objdata = this.ItemPetition.find((arr) => arr.no === item.no);
        objdata["see_id"] = true;
        this.ItemPetition.splice(objIndex, 1, objdata);
      }
    },
  },
  watch: {
    tab(val) {

      if (val === 0) {
        this.ColorSlider = "#077893";
      } else if (val === 1) {
        this.ColorSlider = "warning";
      } else if (val === 2) {
        this.ColorSlider = "indigo";
      } else if (val === 3) {
        this.ColorSlider = "green";
      } else {
        this.ColorSlider = "error";
      }
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
